import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      form: {
        color: '#333333',
        fontFamily: 'Microsoft Yahei',
        fontWeight: 'normal',
        fontSize: 12
      },
      fontfamilyoptions: [{
        label: '微软雅黑',
        value: 'Microsoft Yahei'
      }],
      fontweightoptions: [{
        label: '常规体',
        value: 'normal'
      }, {
        label: '粗体',
        value: 'bold'
      }],
      alias: ['color', 'fontFamily', 'fontWeight', 'fontSize']
    };
  },
  watch: {
    value(newValue) {
      // console.log('fontstylewatch');
      // console.log(newValue);
      if (Object.keys(newValue).length === 0) {
        this.fontChange();
      } else {
        Object.keys(newValue).forEach(child => {
          let newfont = {
            ...newValue
          };
          if (this.alias.includes(child)) {
            this.form[child] = newfont[child] && newfont[child].toString().includes('px') ? parseInt(newfont[child]) : newfont[child];
          }
        });
      }
    }
  },
  mounted() {
    // console.log('fontstylemounted');
    // console.log(this.value);
    if (Object.keys(this.value).length === 0) {
      this.fontChange();
    }
  },
  methods: {
    fontChange(val) {
      // console.log('fontstylemethods');
      // console.log('val');
      let data = {
        ...this.form
      };
      data.fontSize = data.fontSize + 'px';
      let obj = {};
      obj[this.title] = data;
      this.$emit('fontStyle', obj);
    }
  }
};